export enum PosthogEvents {
  AddRecommendation = 'Add Recommendation',
  CreatorProfile = 'Creator Profile',
  BENlabsExtension = 'BENlabs Extension',
  UserActions = 'User actions',
  GetMoreRecommendations = 'Get More Recommendations',
  FilterListClick = 'Filter List Click',
  OverRecommendations = 'Over Recommendation',
  TTCMIntegration = 'TTCM Integration',
  CampaignSetup = 'Campaign Setup',
  Reporting = 'Reporting',
  MissingWatchData = 'Missing Watch Data',
}
export enum PosthogActions {
  CardInputChnage = 'Changed expected values in card',
  CardOpenedChannel = 'Opened creator channel through card',
  CardOpenedProduction = 'Opened production edit through card',
  CardSectionRating = 'Rate section in card',
  CopyToClipboard = 'Copied to clipboard',
  DrawerTabChange = 'Changed drawer tab',
  EditProduction = 'Edit Production',
  FilterPlacementMetrics = 'Filter placement metrics',
  FilterProductionMetrics = 'Filter production metrics',
  OpenModal = 'Opened modal',
  OpenBENlabsExtension = 'Open BENlabs Extension',
  OpenCreatorPlatform = 'Open Creator Platform',
  OpenDrawer = 'Open Drawer',
  PageLoad = 'Page Navigation Load',
  PageNavigation = 'Page Navigation Click',
  MissingDemographics = 'No demographics data found',
  SimilarSearchType = 'Similar search type',
  ViewPlacement = 'View Placement',
  ViewProduction = 'View Production',
}

export enum PosthogActionPhases {
  Load = 'Load',
  Unlock = 'Unlock',
  Submit = 'Submit',
  Reset = 'Reset',
  Cancel = 'Cancel',
}
